import { render, staticRenderFns } from "./DispensationHandlingModal.vue?vue&type=template&id=edfc4a80&scoped=true"
import script from "./DispensationHandlingModal.vue?vue&type=script&lang=js"
export * from "./DispensationHandlingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfc4a80",
  null
  
)

export default component.exports